import { DropTargetMonitor, XYCoord } from 'react-dnd';
import { ReorderBody } from 'app/components/DraggableListRow/types';

const CURSOR_OFFSET = 16;
export const showRowTopShadow = (
  divRef: HTMLDivElement | null,
  monitor: DropTargetMonitor
): boolean => {
  const hoverBoundingRect = divRef?.getBoundingClientRect();

  if (hoverBoundingRect) {
    const rowHeight = hoverBoundingRect.bottom - hoverBoundingRect.top;
    const hoverMiddleY = rowHeight / 2;
    const initialClientSourceOffset = monitor.getInitialSourceClientOffset();
    const differenceFromInitialSource = monitor.getDifferenceFromInitialOffset();

    if (initialClientSourceOffset && differenceFromInitialSource) {
      // Gives info if user draged source TOP (positive number), or DOWN (negative number)
      const hoverOffsetY = initialClientSourceOffset.y - hoverBoundingRect.top;

      const hoverPositionInRow =
        (rowHeight + differenceFromInitialSource.y + hoverOffsetY) / 2;

      if (hoverPositionInRow < hoverMiddleY) {
        return true;
      }
    }
  }

  return false;
};

export const getItemStyles = (
  initialCursorOffset: XYCoord | null,
  initialOffset: XYCoord | null,
  currentOffset: XYCoord | null
) => {
  if (!initialOffset || !currentOffset || !initialCursorOffset) {
    return {
      display: 'none',
    };
  }

  const x =
    initialCursorOffset?.x +
    (currentOffset.x - initialOffset.x + CURSOR_OFFSET);
  const y =
    initialCursorOffset?.y +
    (currentOffset.y - initialOffset.y + CURSOR_OFFSET);
  const transform = `translate(${x}px, ${y}px)`;

  return {
    transform,
    display: 'flex',
    flex: '0 0 auto',
    maxWidth: '300px',
  };
};

export const getReorderBody = (
  movingGuid: string,
  afterGuid: string,
  notToTop = false
): ReorderBody => {
  const requestBody: ReorderBody = {
    guid: movingGuid,
  };

  if (notToTop) {
    requestBody.afterGuid = afterGuid;
  }

  return requestBody;
};
